module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe9b1e461f09f428f813ac2f33705954d.e9b1e461.png";